import { Translation } from '@ps/web-shared-components';
import { mapKeys } from 'lodash';
import React, { useEffect, useState } from 'react';

import { LimitType } from '@swf/core/enums';
import useRequest from '@swf/core/hooks/useRequest';

import type { WeeklyLimits } from '../../../../types/responsibleGamingLimits';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import {
  TXTWCL_Accumulated_Limit,
  TXTWCL_Accumulated_limit_is_a_cap_on__ELL,
  TXTWCL_Responsible_Gaming_Limits
} from './RMFAccumulatedBuyInLimit.messages.json';
import AccumulatedBuyInLimits from './components/AccumulatedBuyInLimits/AccumulatedBuyInLimits';

const limitTypes: Record<string, string> = {
  [LimitType.POKER]: 'pokerLimit',
  [LimitType.SPORT]: 'sportLimit'
};

const RMFAccumulatedBuyInLimit: React.FC = () => {
  const request = useRequest();
  const [initialLimits, setInitialLimits] = useState<WeeklyLimits>({
    pokerLimit: -1,
    sportLimit: -1
  });

  useEffect(() => {
    request({
      service: 'responsiblegaming.bettinglimit',
      body: { extended: 0, sport: 1 }
    }).subscribe(({ body }) => {
      const limits = mapKeys(body, (_, key) => limitTypes[key]) as WeeklyLimits;
      setInitialLimits(limits);
    });
  }, [request]);

  return (
    <Container
      page={RMFAccumulatedBuyInLimit}
      headerProps={{
        title: <Translation {...TXTWCL_Responsible_Gaming_Limits} />
      }}
      pageTopTitle={<Translation {...TXTWCL_Accumulated_Limit} />}
      pageTopSubtitle={<Translation {...TXTWCL_Accumulated_limit_is_a_cap_on__ELL} />}
    >
      <AccumulatedBuyInLimits fieldName="rmf.weekly" limits={initialLimits} />
      <CTAButton />
    </Container>
  );
};

RMFAccumulatedBuyInLimit.displayName = 'RMFAccumulatedBuyInLimit';

export default RMFAccumulatedBuyInLimit;
